import { render, staticRenderFns } from "./newlyAdded.vue?vue&type=template&id=3cd71010&"
import script from "./newlyAdded.vue?vue&type=script&lang=js&"
export * from "./newlyAdded.vue?vue&type=script&lang=js&"
import style0 from "./newlyAdded.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports